import Container from '@mui/material/Container'
import React from 'react'
import { Outlet } from 'react-router-dom'
import { UserReportsHeader } from '../Views/UserReports/UserReportsHeader'

export const UserReportsLayout = () => {
  return (
    <>
      <UserReportsHeader/>
      <Container maxWidth={'xl'} sx={{ px: 5, mx: 'auto' }}>
        <Outlet />
      </Container>
    </>
  )
}
